export default __webpack_public_path__ + "static/media/sidebar-right.87a503ce.jpg";